import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/queryKeys';
import healthCheckService from 'services/api/health-check/healthCheckService';

const POLL_INTERVAL_MS = 60_000;

export const useHealthCheck = () => {
  return useQuery(
    [QUERY_KEYS.HEALTH_CHECK.STATUS],
    () => healthCheckService.getStatus(),
    {
      refetchInterval: POLL_INTERVAL_MS,
      refetchIntervalInBackground: true,
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );
};
